export class AlarmFilter {
  uid: string;
  name: string;
  placement: string;
  defaultValue: any;
  currentValue?: any;

  constructor(uid$: string, name$: string, placement$: string, defaultValue$: any) {
    this.uid = uid$;
    this.name = name$;
    this.placement = placement$;
    this.defaultValue = defaultValue$;
  }
}

type AlarmStateFrench =
  'PRÉSENTE NON ACQUITTÉE' |
  'PRÉSENTE ACQUITTÉE' |
  'ABSENTE NON ACQUITTÉE' |
  'ABSENTE ACQUITTÉE' |
  'INHIBÉE';
const AlarmStateFrench = (() => {
  const RAISED: AlarmStateFrench = 'PRÉSENTE NON ACQUITTÉE';
  const RAISED_ACKNOWLEDGED: AlarmStateFrench = 'PRÉSENTE ACQUITTÉE';
  const RESETED: AlarmStateFrench = 'ABSENTE NON ACQUITTÉE';
  const RESETED_ACKNOWLEDGED: AlarmStateFrench = 'ABSENTE ACQUITTÉE';
  const INHIBITED: AlarmStateFrench = 'INHIBÉE';
  function values(): AlarmStateFrench[] {
    return [
      RAISED,
      RAISED_ACKNOWLEDGED,
      RESETED,
      RESETED_ACKNOWLEDGED,
      INHIBITED
    ];
  }
  return { RAISED, RAISED_ACKNOWLEDGED, RESETED, RESETED_ACKNOWLEDGED, INHIBITED, values };
})();

export { AlarmStateFrench };

export class AlarmStateTranslation {
  key: string;
  fr: string;
  en: string;
}

const AlarmStateTranslations = (() => {
  function values(): AlarmStateTranslation[] {
    return [
      { key: 'raised', fr: 'présente non acquittée', en: 'raised'},
      { key: 'raised_acknowledged', fr: 'présente acquittée', en: 'raised acknowledged'},
      { key: 'reseted', fr: 'absente non acquittée', en: 'reseted'},
      { key: 'reseted_acknowledged', fr: 'absente acquittée', en: 'reseted acknowledged'},
      { key: 'inhibited', fr: 'inhibée', en: 'inhibited'}
    ];
  }
  return { values };
})();

export { AlarmStateTranslations };
